module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/barra-de-ouro-b00147edff63f125d7dc75562b98364a.webp";